import { DisableIntegrationAction } from '@modules/integrationsV2/components/DisableIntegrationAction';
import { ReauthorizeIntegrationAction } from '@modules/integrationsV2/components/ReauthorizeIntegrationAction';
import { trackIntegrationPageEvent } from '@modules/integrationsV2/utils';
import { MoreVertRounded } from '@mui/icons-material';
import { IconButton, Menu } from '@mui/material';
import {
  IntegrationChannelViewFragment,
  IntegrationType,
} from 'generated/graphql';
import { useState } from 'react';
import { UUID } from 'v2/core/entities/uuid';

interface ConnectedIntegrationListActionsMenuProps {
  integrationID: UUID;
  integrationChannel: IntegrationChannelViewFragment;
  integrationType: IntegrationType;
  namespace: string | undefined;
}

export const ConnectedIntegrationListActionsMenu = ({
  integrationChannel,
  integrationID,
  integrationType,
  namespace,
}: ConnectedIntegrationListActionsMenuProps) => {
  const [menuAnchor, setMenuAnchor] = useState<null | HTMLElement>(null);

  const isMenuOpen = Boolean(menuAnchor);

  const openMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
    setMenuAnchor(event.currentTarget);
    trackIntegrationPageEvent({
      eventName: 'Integrations - Integration Actions Menu Opened',
      integration: {
        channelType: integrationChannel.type,
        integrationType,
        namespace,
      },
    });
  };
  const closeMenu = () => {
    setMenuAnchor(null);
  };

  return (
    <>
      <IconButton color="primary" onClick={openMenu} size="small">
        <MoreVertRounded />
      </IconButton>
      <Menu
        anchorEl={menuAnchor}
        open={isMenuOpen}
        onClose={closeMenu}
        sx={{
          zIndex: (theme) => theme.zIndex.drawer - 1,
        }}
        slotProps={{
          paper: {
            sx: {
              minWidth: '150px',
            },
          },
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <DisableIntegrationAction
          channelType={integrationChannel.type}
          integrationID={integrationID}
          integrationType={integrationType}
          namespace={namespace}
        />
        <ReauthorizeIntegrationAction
          integrationChannel={integrationChannel}
          integrationID={integrationID}
          integrationType={integrationType}
        />
      </Menu>
    </>
  );
};
